"use strict";

var _regeneratorRuntime = require("/opt/build/repo/app/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = exports.getConfigFromNetwork = exports.getConfigFromCache = void 0;

var getConfigFromCache = function getConfigFromCache() {
  var _a, _b;

  if (typeof window === "undefined") {
    return;
  }

  var configFromCache = JSON.parse((_a = window.sessionStorage.getItem("reactify-search:config")) !== null && _a !== void 0 ? _a : "null");

  if (configFromCache) {
    if (((_b = configFromCache.config.cache) === null || _b === void 0 ? void 0 : _b.enabled) === false) {
      return;
    }

    return configFromCache.config;
  }

  return;
};

exports.getConfigFromCache = getConfigFromCache;

var getConfigFromNetwork = function getConfigFromNetwork(shopifyPermanentDomain) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _a, _b, configFromNetwork;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("https://config.usereactify.com/?shop=".concat(shopifyPermanentDomain)).then(function (response) {
              return response.json();
            });

          case 3:
            _context.t1 = _a = _context.sent;
            _context.t0 = _context.t1 === null;

            if (_context.t0) {
              _context.next = 7;
              break;
            }

            _context.t0 = _a === void 0;

          case 7:
            if (!_context.t0) {
              _context.next = 11;
              break;
            }

            _context.t2 = void 0;
            _context.next = 12;
            break;

          case 11:
            _context.t2 = _a.body;

          case 12:
            configFromNetwork = _context.t2;
            _context.next = 29;
            break;

          case 15:
            _context.prev = 15;
            _context.t3 = _context["catch"](0);
            _context.next = 19;
            return fetch("https://config.usereactify.com/?shop=".concat(shopifyPermanentDomain)).then(function (response) {
              return response.json();
            });

          case 19:
            _context.t5 = _b = _context.sent;
            _context.t4 = _context.t5 === null;

            if (_context.t4) {
              _context.next = 23;
              break;
            }

            _context.t4 = _b === void 0;

          case 23:
            if (!_context.t4) {
              _context.next = 27;
              break;
            }

            _context.t6 = void 0;
            _context.next = 28;
            break;

          case 27:
            _context.t6 = _b.body;

          case 28:
            configFromNetwork = _context.t6;

          case 29:
            return _context.abrupt("return", configFromNetwork);

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));
};

exports.getConfigFromNetwork = getConfigFromNetwork;

var getConfig = function getConfig(shopifyPermanentDomain) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var configFromCache, configFromNetwork;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            configFromCache = (0, exports.getConfigFromCache)();

            if (!configFromCache) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", configFromCache);

          case 3:
            _context2.next = 5;
            return (0, exports.getConfigFromNetwork)(shopifyPermanentDomain);

          case 5:
            configFromNetwork = _context2.sent;

            if (configFromNetwork) {
              _context2.next = 8;
              break;
            }

            throw new Error("Unable to load config");

          case 8:
            if (typeof window !== "undefined") {
              window.sessionStorage.setItem("reactify-search:config", JSON.stringify({
                config: configFromNetwork
              }));
            }

            return _context2.abrupt("return", configFromNetwork);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

exports.getConfig = getConfig;